export const site = {
  name: 'Solusi Aman',
  domain: 'https://solusiaman.com',
  whatsapp: '6281388220734',
  salesContact: 'Vitry',
};

export const services = [
  {
    id: '01',
    slug: 'offensive-security',
    eyebrow: 'OFFENSIVE SECURITY & PENTESTING',
    title: 'Find and fix real security risks before attackers do.',
    description: 'Security assessments from an attacker’s perspective, focused on exploitable weaknesses and actionable remediation.',
    bullets: ['Web application & API penetration testing','Android application security testing','Authentication, authorization & business logic','Vulnerability validation & remediation guidance'],
    cta: 'Discuss Security Assessment',
    message: 'Hi Vitry, I would like to discuss a security assessment.'
  },
  {
    id: '02',
    slug: 'secure-software-development',
    eyebrow: 'SECURE SOFTWARE DEVELOPMENT',
    title: 'Build reliable software with security in mind.',
    description: 'Custom web and mobile applications engineered for real business needs, with clean architecture and maintainable code.',
    bullets: ['Full-stack web application development','Native Android development (Kotlin)','Backend, API & database engineering','Secure architecture & deployment'],
    cta: 'Discuss Development',
    message: 'Hi Vitry, I would like to discuss software development.'
  }
] as const;

export const newsItems = [
  {
    slug: 'panduan-etis-ai-penetration-testing',
    category: 'Security',
    date: '2026-10-09',
    title: 'Ethical Use of AI in Penetration Testing',
    excerpt: 'An overview of responsible AI use in penetration testing, including safe practices and compliance considerations.'
  },
  {
    slug: 'mesin-coding-otomatis-ai-api-key',
    category: 'Engineering',
    date: '2026-10-09',
    title: 'Building an AI-Assisted Coding Workflow with an API Key',
    excerpt: 'A practical guide to AI-assisted coding workflows, with implementation and security considerations.'
  }
] as const;
